import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAppStore } from "@/store/useAppStore";

/** Redirect authenticated users away from login/signup pages. */
export function GuestOnly({ children }) {
  const { isAuthed, authReady } = useAppStore();

  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="animate-spin text-indigo-600" size={28} aria-hidden />
      </div>
    );
  }

  if (isAuthed) return <Navigate to="/today" replace />;

  return children;
}

GuestOnly.propTypes = {
  children: PropTypes.node,
};
